import { render } from "./Cursor.vue?vue&type=template&id=93906f8a"
const script = {}

import "./Cursor.vue?vue&type=style&index=0&id=93906f8a&lang=scss"
script.render = render

export default script